import { Row, StyledContainer, StyledSectionTitle } from './utils'

export const NotificationsSection = (props) => {
    const { section, notifications, handleUpdate, updatingItem } = props

    return (
        <>
            <StyledSectionTitle
                paddingY="16px"
                data-ai-explain={`Notification group: ${section}`}
            >
                {section}
            </StyledSectionTitle>

            <StyledContainer>
                {notifications.map((n) => (
                    <Row
                        key={n.id}
                        label={n.localizedDefaultPreferenceName}
                        description={n.localizedDefaultPreferenceDescription}
                        active={updatingItem.id === n.id ? false : n.active}
                        loading={updatingItem.id === n.id}
                        onChange={() => handleUpdate(n, !n.active)}
                    />
                ))}
            </StyledContainer>
        </>
    )
}
